module.exports = __webpack_public_path__ + "static/media/integrity-laptop.56630eb5.jpg";